import { ToggleButton as MuiToggleButton } from '@mui/material';
import { ReactNode } from 'react';

interface IProps {
  label: string;
  value: string | number;
  selected: boolean;
  disabled?: boolean;
  startAdornment?: ReactNode;
  onClick?: () => void;
}

const ToggleButton = ({ label, value, selected, disabled, startAdornment, onClick }: IProps) => {
  return (
    <MuiToggleButton
      color='primary'
      disabled={disabled}
      selected={selected}
      value={value}
      onClick={onClick}
      aria-label={label}
    >
      <div className='flex flex-row items-center gap-x-2 whitespace-nowrap'>
        {!!startAdornment && startAdornment}
        <span>{label}</span>
      </div>
    </MuiToggleButton>
  );
};

export default ToggleButton;
